"use client";

import compareDates from "@/common/function/compareDate";
import getStartAndEndOfDay from "@/common/function/getStartAndEndOfDay";
import { GeneralPropsType } from "@/common/types";
import determineParent from "@/components/AffiliateGroup/determineParent";
import ChangePasswordLogin from "@/components/ChangePasswordLogin/page";
import ForgotPassword from "@/components/ForgotPassword/page";
import LoginApp from "@/components/LoginApp/page";
import RequireData from "@/components/RequireData";
import useFetchApi from "@/hook/useFetch";
import addDevice from "@/services/addDeviceService";
import getLogPartialBonusesService from "@/services/affiliate/getLogPartialBonusesService";
import { PartialBonuses } from "@/services/affiliate/type";
import check2FAService from "@/services/check2FAService";
import checkEmailAuthenticationService from "@/services/checkEmailAuthenticationService";
import checkKycService from "@/services/checkKycService";
import checkManagementPackageService from "@/services/checkManagementPackageService";
import checkRequiredKYCForBonusService from "@/services/checkRequiredKYCForBonusService";
import fetchMaxoutService from "@/services/fetchMaxoutService";
import getActivitiesService from "@/services/getActivitiesService";
import getAffiliateService from "@/services/getAffiliateService";
import getAnnouncementService from "@/services/getAnnouncementService";
import getBoostAprService from "@/services/getBoostAprService";
import getCampaignsService from "@/services/getCampaignsService";
import getConnectedSocialsService from "@/services/getConnectedSocialsService";
import getCouponService from "@/services/getCouponService";
import getDeviceInfo from "@/services/getDeviceInfo";
import getGiftCardsService from "@/services/getGiftCardsService";
import getLimitInvestService from "@/services/getLimitInvest";
import getMissionsService from "@/services/getMissionsService";
import getOverrideRateService from "@/services/getOverrideRateService";
import getPackageInfo from "@/services/getPackageInfo";
import getPackageServiceV2 from "@/services/getPackageServiceV2";
import getPortfolioService from "@/services/getPortfolioService";
import getPortfolioTotalAmount from "@/services/getPortfolioTotalAmount";
import getPortfolioTotalProfit from "@/services/getPortfolioTotalProfit";
import getRankDataService from "@/services/getRankDataService";
import getReferralService from "@/services/getReferralService";
import getSubPaymentFeeService from "@/services/getSubPaymentFeeService";
import getUserInfo from "@/services/getUserInfo";
import getUserWallets from "@/services/getUserWallets";
import logoutService from "@/services/logoutService";
import PocketBase from "pocketbase";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { useAuth } from "../Auth";
import { useGlobalData } from "../GlobalData";
import { useRealtimeData } from "../RealtimeData";
export const PocketBaseContext = createContext<any>(null);
function PocketBaseDataProvider({
  children
}: GeneralPropsType) {
  const {
    tokensRateRef: tokensRate,
    setChartData,
    activityData,
    setActivityData,
    announcementData,
    kycDataUser,
    setAnnouncementData,
    setKycDataUser,
    setMaxoutData,
    setRankData,
    setCampaignsData,
    setCoupponsData,
    setPortfolioData,
    setPortfolioProfitData,
    setPortfolioAmountData,
    setConnectedSocialsData,
    setCheckManagementPackageData,
    setAffiliateData,
    setGeneralAffiliateData,
    setReferralData,
    setAffiliateViewing,
    setAffiliateDataOverview,
    setIsCheckKycForBonus,
    setAuthenInfo,
    setUserWallets,
    rewardFilterTab,
    setCheck2FA,
    setGiftCardsData,
    setInvestRounds,
    getMostLockTime,
    authenInfo,
    setMeDevice,
    deviceInfo,
    amountDatesSelected,
    profitDatesSelected,
    currentDevice,
    setCurrentDevice,
    setUserInfo,
    setMissionsData,
    currentDeviceRef,
    boostAprData,
    setBoostAprData,
    setPackagesInfo,
    packagePagination,
    setPackageLoading,
    setSubPaymentFeeData,
    subPaymentFeeData,
    setLimitInvest
  } = useGlobalData();
  const {
    startOfDay,
    endOfDay
  } = getStartAndEndOfDay(amountDatesSelected?.startDate, amountDatesSelected?.endDate);
  const {
    startOfDay: startOfDayProfit,
    endOfDay: endOfDayProfit
  } = getStartAndEndOfDay(profitDatesSelected?.startDate, profitDatesSelected?.endDate);
  let intervalRef = useRef<any>();
  const {
    packagesData,
    setPackagesData,
    setTokensRateState,
    tokensRateState
  } = useRealtimeData();
  const {
    userId,
    token,
    isHaveAffParent,
    username,
    walletAddress,
    loginAppData,
    loginAppStep,
    setLoginAppStep,
    bm,
    useBiometryFailed
  } = useAuth();
  const [triggerTransaction, setTriggerTransaction] = useState<any>(undefined);
  const [trackingConditionsGift, setTrackingConditionsGift] = useState<any>(undefined);
  const [pb, setPb] = useState(new PocketBase(process.env.NEXT_PUBLIC_PB_URL));
  const [isTheFirstTimeFetchData, setIsTheFirstTimeFetchData] = useState(true);
  const {
    data: partialBonuses,
    fetchData: getLogPartialBonuses
  } = useFetchApi<PartialBonuses>(getLogPartialBonusesService);
  const [cookies, setCookie, removeCookie] = useCookies(["sessionCasdoor"]);
  function getISOStringsForPastWeek(numberOfDay: number = 7): string[] {
    const today = new Date();
    const pastWeekISOStrings: string[] = [];
    for (let i = 0; i < numberOfDay; i++) {
      const pastDate = new Date(today);
      pastDate.setDate(today.getDate() - i);
      pastWeekISOStrings.push(pastDate.toISOString().split("T")[0]);
    }
    return pastWeekISOStrings.reverse();
  }
  const getSubPaymentFees = async () => {
    const res = await getSubPaymentFeeService();
    if (res?.data) {
      setSubPaymentFeeData(res?.data);
    }
  };
  const getDataToChart = () => {
    const getDataForDays = async (days: string[]) => {
      const promises = days.map(async day => {
        const chartDataRes = await pb.collection("price_token").getList(1, 1, {
          sort: "created",
          filter: `created ~ "${day}" && data!=null`,
          requestKey: null
        });
        return chartDataRes.items[0];
      });
      const results = await Promise.all(promises);
      return results;
    };
    const dayToDisplay = getISOStringsForPastWeek();
    getDataForDays(dayToDisplay).then(results => {
      const filterData = [...results.filter(Boolean)];
      setChartData(filterData);
      localStorage.setItem("tonRate", JSON.stringify(filterData));
    });
  };
  const getData = (token: string): void => {
    getSubPaymentFees();
    getOverrideRateService(data => {
      setTokensRateState((pre: any) => {
        return {
          ...pre,
          ...(data?.rateToken as any),
          updateNextTime: Date.now() + data?.secondsTrackingExchangeRate * 1000
        };
      });
    });
    !announcementData && getAnnouncementService(token, res => {
      setAnnouncementData(res);
    });
    !kycDataUser && checkKycService(token, data => {
      setKycDataUser(data);
    });
    fetchMaxoutService(token, data => {
      setMaxoutData(data);
    });
    getReferralService(token, (data: any) => {
      setReferralData(data?.result?.data);
    }, undefined, {
      filter: rewardFilterTab ?? "week"
    });
    getAffiliateService(token, (data: any) => {
      if (!data?.result?.data) {
        return;
      }
      setGeneralAffiliateData(JSON.parse(JSON.stringify(data?.result?.data)));
      determineParent(data?.result?.data);
      setAffiliateData(data?.result?.data);
      setAffiliateDataOverview(data?.result);
      setAffiliateViewing(data?.result?.data);
    });
    getLogPartialBonuses();
    getRankDataService(token, (data: any) => {
      setRankData(data?.result);
    });
    getCampaignsService({
      token
    }, (data: any) => {
      setCampaignsData(data?.result);
      setInvestRounds((prev: any) => {
        return {
          ...prev,
          campaign: {
            apr: getMostLockTime(data?.result?.details?.[0]?.lockTimes)?.apr,
            name: data?.result?.details?.[0]?.name
          }
        };
      });
    });
    getCouponService(token, (data: any) => {
      setCoupponsData(data?.coupons);
    });
    getBoostAprService(token, (data: any) => {
      setBoostAprData(data);
    });
    getPortfolioService(token, (data: any) => {
      setPortfolioData(data);
    });
    getUserWallets(token, (data: any) => {
      setUserWallets(data);
    });
    getPortfolioTotalProfit(token, (data: any) => {
      setPortfolioProfitData(data);
    }, undefined, {
      startDate: startOfDayProfit,
      endDate: endOfDayProfit,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    });
    getPortfolioTotalAmount(token, (data: any) => {
      setPortfolioAmountData(data);
    }, undefined,
    // {
    //     startDate: "",
    //     endDate: "",
    //     timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    // }
    {
      startDate: startOfDay,
      endDate: endOfDay,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    });
    getConnectedSocialsService(token, (data: any) => {
      setConnectedSocialsData(data);
    });
    checkManagementPackageService(token, (data: any) => {
      setCheckManagementPackageData(data);
    });
    checkRequiredKYCForBonusService(token, (data: any) => {
      setIsCheckKycForBonus(data.result.success);
    });
    checkEmailAuthenticationService(token, (data: any) => {
      setAuthenInfo(data);
    });
    check2FAService(token, (data: any) => {
      setCheck2FA(data);
    });
    getGiftCardsService(token, (data: any) => {
      setGiftCardsData(data);
    });
    setIsTheFirstTimeFetchData(false);
    getMissionsService(token, (data: any) => {
      setMissionsData(data);
    });
    getLimitInvestService(token, (data: any) => {
      setLimitInvest(data?.result);
    });
  };
  const updateData = async (token: string) => {
    console.log("update dataaa");
    getOverrideRateService(data => {
      setTokensRateState((pre: any) => {
        return {
          ...pre,
          ...(data?.rateToken as any)
        };
      });
    });
    getLogPartialBonuses();
    getSubPaymentFees();
    getPackageServiceV2(packagePagination, data => {
      console.log(data);
      setPackagesData(data);
    }, undefined);
    const [fetchMaxoutServiceRes, getReferralServiceRes, getAffiliateServiceRes, getRankDataServiceRes, getCampaignsServiceRes, getCouponServiceRes, getPortfolioServiceRes, getUserWalletsRes, getPortfolioTotalProfitRes, getPortfolioTotalAmountRes, getConnectedSocialsServiceRes, checkManagementPackageServiceRes, checkRequiredKYCForBonusServiceRes, checkEmailAuthenticationServiceRes, check2FAServiceRes, getGiftCardsServiceRes, userInfoRes, getMissionsServiceRes, getBoostAprServiceRes, getLimitInvestServiceRes] = await Promise.allSettled([fetchMaxoutService(token), getReferralService(token, undefined, undefined, {
      filter: rewardFilterTab ?? "week"
    }), getAffiliateService(token), getRankDataService(token), getCampaignsService({
      token
    }), getCouponService(token), getPortfolioService(token), getUserWallets(token), getPortfolioTotalProfit(token, undefined, undefined, {
      startDate: startOfDayProfit,
      endDate: endOfDayProfit,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }), getPortfolioTotalAmount(token, undefined, undefined, {
      startDate: startOfDay,
      endDate: endOfDay,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }), getConnectedSocialsService(token), checkManagementPackageService(token), checkRequiredKYCForBonusService(token), checkEmailAuthenticationService(token), check2FAService(token), getGiftCardsService(token), getUserInfo(token), getMissionsService(token), getBoostAprService(token), getLimitInvestService(token)]);
    if (fetchMaxoutServiceRes.status == "fulfilled") {
      setMaxoutData(fetchMaxoutServiceRes.value?.data);
    }
    if (getReferralServiceRes.status == "fulfilled") {
      setReferralData(getReferralServiceRes.value?.result?.data);
    }
    if (getAffiliateServiceRes.status == "fulfilled") {
      if (!getAffiliateServiceRes.value?.result?.data) {
        return;
      }
      setGeneralAffiliateData(JSON.parse(JSON.stringify(getAffiliateServiceRes.value?.result?.data)));
      determineParent(getAffiliateServiceRes.value?.result?.data);
      setAffiliateData(getAffiliateServiceRes.value?.result?.data);
      setAffiliateDataOverview(getAffiliateServiceRes.value?.result);
      setAffiliateViewing(getAffiliateServiceRes.value?.result?.data);
    }
    if (getRankDataServiceRes.status == "fulfilled") {
      setRankData(getRankDataServiceRes.value?.result);
    }
    if (getCampaignsServiceRes.status == "fulfilled") {
      setCampaignsData(getCampaignsServiceRes.value?.result);
    }
    if (getCouponServiceRes.status == "fulfilled") {
      setCoupponsData(getCouponServiceRes?.value?.coupons);
    }
    if (getPortfolioServiceRes.status == "fulfilled") {
      setPortfolioData(getPortfolioServiceRes.value);
    }
    if (getUserWalletsRes.status == "fulfilled") {
      setUserWallets(getUserWalletsRes?.value);
    }
    if (getPortfolioTotalProfitRes.status == "fulfilled") {
      setPortfolioProfitData(getPortfolioTotalProfitRes.value);
    }
    if (getPortfolioTotalAmountRes.status == "fulfilled") {
      setPortfolioAmountData(getPortfolioTotalAmountRes.value);
    }
    if (getConnectedSocialsServiceRes.status == "fulfilled") {
      setConnectedSocialsData(getConnectedSocialsServiceRes.value);
    }
    if (checkManagementPackageServiceRes.status == "fulfilled") {
      setCheckManagementPackageData(checkManagementPackageServiceRes.value);
    }
    if (checkRequiredKYCForBonusServiceRes.status == "fulfilled") {
      setIsCheckKycForBonus(checkRequiredKYCForBonusServiceRes?.value?.result.success);
    }
    if (checkEmailAuthenticationServiceRes.status == "fulfilled") {
      setAuthenInfo(checkEmailAuthenticationServiceRes.value);
    }
    if (check2FAServiceRes.status == "fulfilled") {
      setCheck2FA(check2FAServiceRes.value);
    }
    if (getGiftCardsServiceRes.status == "fulfilled") {
      setGiftCardsData(getGiftCardsServiceRes.value.data);
    }
    if (userInfoRes.status == "fulfilled") {
      setUserInfo(userInfoRes.value);
    }
    if (getMissionsServiceRes.status == "fulfilled") {
      setMissionsData(getMissionsServiceRes.value);
    }
    if (getBoostAprServiceRes.status == "fulfilled") {
      setBoostAprData(getBoostAprServiceRes.value);
    }
    if (getLimitInvestServiceRes.status == "fulfilled") {
      setLimitInvest(getLimitInvestServiceRes.value?.result);
    }
  };
  useEffect(() => {
    if (!token || !packagePagination) return;
    setPackageLoading(true);
    getPackageServiceV2(packagePagination, data => {
      setPackagesData(data);
      setPackageLoading(false);
    }, () => setPackageLoading(false));
  }, [token, packagePagination]);
  useEffect(() => {
    if (!userId) return;
    getPackageInfo(pb, userId, data => {
      console.log(data, "set packages info");
      setPackagesInfo(data);
    });
  }, [userId]);
  useEffect(() => {
    if (!deviceInfo || !token) return;
    addDevice({
      deviceInfo
    }, token, res => {
      console.log(res, "res");
      getDeviceInfo({
        deviceId: deviceInfo?.hash
      }, token, (data: any) => {
        setMeDevice(data);
        const isSetup = data?.some((device: any) => device?.primary);
        const device = data?.find((device: any) => device?.current);
        setCurrentDevice({
          ...device,
          isSetup
        });
        currentDeviceRef.current = {
          ...device,
          isSetup
        };
      });
    });
  }, [token, deviceInfo]);
  useEffect(() => {
    (async () => {
      try {
        await pb.collection("users").authWithPassword(process.env.NEXT_PUBLIC_PB_EMAIL || "", process.env.NEXT_PUBLIC_PB_PASSWORD || "");
        pb.collection("user_packages").subscribe("*", function (e) {
          const userIdLocal = localStorage.getItem("userIdLocal");
          if (!userIdLocal) return;
          if (e?.record?.user_id == userIdLocal) {
            console.log("🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀 ~ realtime user_packages:", e.record);
            setPackagesInfo({
              available_reward: e.record.available_reward,
              total_investment: e.record.total_investment
            });
          }
        });
        pb.collection("transactions").subscribe("*", function (e) {
          const userIdLocal = localStorage.getItem("userIdLocal");
          if (!userIdLocal) return;
          if (e?.record?.user_id == userIdLocal) {
            console.log("🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀 ~ realtime record:", e.record);
            setTriggerTransaction(e);
          }
        });
        pb.collection("tracking_conditions_gift").subscribe("*", function (e) {
          const userIdLocal = localStorage.getItem("userIdLocal");
          if (!userIdLocal) return;
          if (e?.record?.user_id == userIdLocal) {
            // console.log("🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀 ~ realtime setTrackingConditionsGift:", e.record);
            setTrackingConditionsGift(e);
          }
        });
        pb.collection("price_token").subscribe("*", function (e) {
          if (!e.record?.data?.rateToken) return;
          tokensRate.current = e.record?.data?.rateToken;
          setTokensRateState((pre: any) => {
            return {
              ...pre,
              ...e.record?.data?.rateToken,
              updatedAt: e.record?.created,
              circleUpdate: e.record?.data?.cycleUpdate ?? 60,
              VND: pre?.VND || e.record?.data?.rateToken?.VND
            };
          });
          console.log("🚀 ~ tokensRateRes ~ tokensRateRes:", tokensRate.current, e, e.record?.data?.rateToken);
        });
        /** Invest round */
        pb.collection("invest_round").subscribe("*", function (e) {
          console.log("🚀 ~ e.record invest_round before if:", e.record);
          if (!!e.record) {
            console.log("🚀 ~ e.record invest_round:", e.record);
            // don't have current
            let x = e?.record?.rounds?.find((e: any) => e.is_current) ?? e?.record?.rounds?.find((e: any) => e.is_next_round);
            setInvestRounds((prev: any) => {
              return {
                ...prev,
                rounds: e.record?.rounds,
                disableInvest: e.record?.disableInvest
              };
            });
            if (x?.is_next_round) {
              getCampaignsService({
                token,
                time: new Date(x.start_time).getTime()
              }, (data: any) => {
                setInvestRounds((prev: any) => {
                  console.log("object =====> ", {
                    rounds: e.record?.rounds,
                    disableInvest: e.record?.disableInvest,
                    campaign: {
                      apr: getMostLockTime(data?.result?.details?.[0]?.lockTimes)?.apr,
                      name: data?.result.details[0]?.name
                    }
                  });
                  return {
                    rounds: e.record?.rounds,
                    disableInvest: e.record?.disableInvest,
                    campaign: {
                      apr: getMostLockTime(data?.result?.details?.[0]?.lockTimes)?.apr,
                      name: data?.result.details[0]?.name
                    }
                  };
                });
              });
            }
          }
        });
        pb.collection("invest_round").getList(1, 1, {
          sort: "-created",
          requestKey: null
        }).then(async res => {
          console.log("🚀 ~ setInvestRounds ~ res.items[0]:", res.items);
          setInvestRounds((prev: any) => {
            console.log("🚀 ~ setInvestRounds ~ prev:", prev);
            return {
              ...prev,
              rounds: res.items[0]?.rounds,
              disableInvest: res.items[0]?.disableInvest
            };
          });
        });
        /** ------ */
        // Device Sessions
        pb.collection("sessions").subscribe("*", async function (e) {
          const userIdLocal = localStorage.getItem("userIdLocal");
          if (!userIdLocal || !currentDeviceRef.current) return;
          console.log("🚀 ~ pb.collection ~ e:", e.record, currentDeviceRef.current);
          const device = currentDeviceRef.current;
          // const userId = JSON.parse(accountInfo)?.user_id;
          if (e?.record?.userId == userIdLocal) {
            if (device?.id != e?.record?.rowDevice) {
              if (e?.record?.action == "dotp-disconnect") {
                setCurrentDevice({
                  ...device,
                  isStep: false
                });
                return;
              }
              return;
            }
            if (e?.record?.action != "dotp-disconnect") {
              setCurrentDevice({
                ...device,
                status: "inactive"
              });
              if (cookies.sessionCasdoor) {
                await logoutService("casdoor");
                removeCookie("sessionCasdoor");
              }
            }
          }
        });
        const tokensRateRes = await pb.collection("price_token").getList(1, 1, {
          sort: "-created",
          requestKey: null
        });
        console.log("🚀 ~ tokensRateRes ~ tokensRateRes get:", tokensRateRes);
        if (tokensRateRes && tokensRateRes.items && tokensRateRes.items[0]) {
          tokensRate.current = tokensRateRes.items[0].data?.rateToken;
          setTokensRateState((pre: any) => {
            return {
              ...pre,
              ...tokensRateRes.items[0].data?.rateToken,
              updatedAt: tokensRateRes.items[0].created,
              circleUpdate: tokensRateRes.items[0].data?.cycleUpdate ?? 60,
              VND: pre?.VND || tokensRateRes.items[0].data?.rateToken?.VND
            };
          });
        }
        const version = localStorage.getItem("current-version");
        if (!version) {
          localStorage.setItem("tonRate", "");
          localStorage.setItem("current-version", "3");
        }
        const tonRateFromLocalStorage = localStorage.getItem("tonRate");
        // If local don't have tonRate, then fetch from server
        if (!tonRateFromLocalStorage) {
          getDataToChart();
        } else {
          let tonRate: any = null;
          try {
            tonRate = JSON.parse(tonRateFromLocalStorage || "");
          } catch (e) {}
          if (tonRate && tonRate.length > 0) {
            if (compareDates(tonRate.sort((a: any, b: any) => new Date(b.created).getTime() - new Date(a.created).getTime())[0].created, new Date().toISOString()) == 0) {
              setChartData(tonRate);
            } else {
              getDataToChart();
            }
          } else {
            getDataToChart();
          }
        }
      } catch (e) {
        console.log("🚀 ~ pocket base error:", e);
      }
    })();
    return () => {
      console.log("🚀 ~ useEffect ~ return: unsubscribe");
      pb?.collection("transactions").unsubscribe();
      pb?.collection("price_token").unsubscribe();
    };
  }, []);
  useEffect(() => {
    try {
      if (packagesData && !!triggerTransaction && userId != triggerTransaction?.record?.user_id || !token || !isHaveAffParent) {
        const transactionType = triggerTransaction?.record?.transaction_type;
        const transactionStatus = triggerTransaction?.record?.status;
        if (transactionType != "gift") return;
        if (username == triggerTransaction?.record?.from_user && transactionStatus == "success") {
          const activityDataFound = activityData?.find((item: any) => item?.status == "processing" && item?.transaction_type == "gift");
          if (!activityDataFound) return;
          const res: any = pb.collection("transactions").getFirstListItem(`hash="${activityDataFound?.hash}"`);
          if (res?.record?.status != "success") return;
          getActivitiesService(pb, walletAddress, userId, data => {
            setActivityData(data);
          });
        }
        return;
      }
      getActivitiesService(pb, walletAddress, userId, data => {
        setActivityData(data);
      });
      getData(token);
    } catch (error) {
      console.log("🚀 ~ useEffect getData ~ error:", error);
    }
  }, [token, isHaveAffParent, userId]);
  useEffect(() => {
    try {
      if (packagesData && !!triggerTransaction && userId != triggerTransaction?.record?.user_id || !token || !isHaveAffParent) {
        const transactionType = triggerTransaction?.record?.transaction_type;
        const transactionStatus = triggerTransaction?.record?.status;
        if (transactionType != "gift") return;
        if (username == triggerTransaction?.record?.from_user && transactionStatus == "success") {
          const activityDataFound = activityData?.find((item: any) => item?.status == "processing" && item?.transaction_type == "gift");
          if (!activityDataFound) return;
          const res: any = pb.collection("transactions").getFirstListItem(`hash="${activityDataFound?.hash}"`);
          if (res?.record?.status != "success") return;
          getActivitiesService(pb, walletAddress, userId, data => {
            setActivityData(data);
          });
        }
        return;
      }
      getActivitiesService(pb, walletAddress, userId, data => {
        setActivityData(data);
      });
      if (!triggerTransaction || triggerTransaction?.record?.status == "processing") {
        console.log("status is processing");
        return;
      }
      updateData(token);
    } catch (error) {
      console.log("🚀 ~ useEffect getData ~ error:", error);
    }
  }, [triggerTransaction]);
  useEffect(() => {
    if (token && trackingConditionsGift?.record?.user_id == userId) {
      // getPackagesService(
      //     token,
      //     (data) => {
      //         setPackagesData(data);
      //     }
      //     // handleIf401
      // );
      getPackageServiceV2(packagePagination, data => {
        setPackagesData(data);
      }, undefined);
    }
  }, [trackingConditionsGift, userId]);
  useEffect(() => {
    if (!tokensRateState?.updateNextTime) return;
    const expired = tokensRateState?.updateNextTime - Date.now();
    if (expired <= 0) {
      getOverrideRateService(data => {
        setTokensRateState((pre: any) => {
          return {
            ...pre,
            ...(data?.rateToken as any),
            updateNextTime: Date.now() + data?.secondsTrackingExchangeRate * 1000
          };
        });
        intervalRef.current = undefined;
      });
    }
  }, [tokensRateState]);
  return <PocketBaseContext.Provider value={{
    triggerTransaction,
    setTriggerTransaction,
    pb,
    partialBonuses
  }} data-sentry-element="unknown" data-sentry-component="PocketBaseDataProvider" data-sentry-source-file="index.tsx">
            {(!loginAppData?.password || loginAppStep == "logged") && children}
            {loginAppData?.password && <>
                    {(loginAppStep == "login" || loginAppStep == "forgot") && (true || !bm || !loginAppData?.isUseBiometry || useBiometryFailed) && <RequireData showLoading={!authenInfo}>
                                <LoginApp />
                            </RequireData>}
                    {loginAppStep == "forgot" && <ForgotPassword />}
                    {loginAppStep == "change-password" && <ChangePasswordLogin initStep="change" />}
                </>}
            {/* </RequireData> */}
        </PocketBaseContext.Provider>;
}
export default PocketBaseDataProvider;
export const usePocketBaseData = () => {
  const context = useContext(PocketBaseContext);
  return context ?? {};
};